<app-header [user]="user()" />

<div class="acd-nfp h-100 pb-lg-4 pb-4">
  <section>
    <div class="container pt-lg-5 pt-4">
      <div class="row">
        <div class="col-12 text-center">
          <h1 class="mt-5 mb-3 f-w-500">404</h1>
          <p class="mb-3">Strona nie została znaleziona</p>
        </div>
        <div class="col-12 d-flex justify-content-center align-items-center">
          <a
            [routerLink]="'/'"
            class="dvp-btn dvp-btn--green dvp-btn--sm justify-content-center align-items-center"
            appGtmClick
            [layer]="{
              event: 'uaevent',
              ecommerce: 'undefined',
              eventCategory: 'not found page',
              eventAction: 'select::go back',
              eventLabel: 'go to main page::' + '/',
              event_name: 'body_button_click',
              module_name: 'go back',
              cta_name: 'go to main page',
              link_url: '/',
            }"
          >
            Powrót
          </a>
        </div>
      </div>
    </div>
  </section>
</div>
